import { portalApi, TAGS } from "api/rtkApi";
import { SERVICES } from "constants/environment";

import type { UUID } from "utils";

import type { TriggerSettlementCode } from "../models/Settlements";

type PostProductionSettlementRequest = {
  customerId: UUID;
};

type PostProductionSettlementResponse = {
  code: TriggerSettlementCode;
  message: string;
};

type PostSandboxSettlementRequest = {
  customerId: UUID;
};

type PostSandboxSettlementResponse = {
  message: string;
};

const extendedApi = portalApi.injectEndpoints({
  endpoints: (builder) => ({
    postProductionSettlement: builder.mutation<
      PostProductionSettlementResponse,
      PostProductionSettlementRequest
    >({
      query: ({ customerId }) => ({
        url: `/customers/${customerId}/settlement/trigger`,
        method: "POST",
      }),
      invalidatesTags: [TAGS.REFUNDS],
      extraOptions: {
        service: SERVICES.CONNECT,
      },
    }),
    postSandboxSettlement: builder.mutation<
      PostSandboxSettlementResponse,
      PostSandboxSettlementRequest
    >({
      query: ({ customerId }) => ({
        url: `/customers/${customerId}/settlement/trigger-mock`,
        method: "POST",
      }),
      invalidatesTags: [TAGS.REFUNDS],
      extraOptions: {
        service: SERVICES.CONNECT,
      },
    }),
  }),
});

export const {
  usePostProductionSettlementMutation,
  usePostSandboxSettlementMutation,
} = extendedApi;
